import { Component,Renderer2,ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl, EventService, ServiceLocatorService } from '@ncs/ncs-lib';
import { SharedataService } from '../service/sharedata.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent extends BaseCtl {
  public param = '';
  public loginId: string = '';
  public auth: any;
  public QRCode: any;
  public DataInQRCode: any;

  constructor(
    public override locator: ServiceLocatorService,
    private eService: EventService,
    public override route: ActivatedRoute,
    private ShareService: SharedataService,
    private renderer:Renderer2,
    private e1:ElementRef,
  ) {
    super('', locator, route);
    let _self = this;
    _self.locator.config
      .getProperty('endpoint.auth')
      .then((property: string) => {
        _self.initApiEndpoint(property);
        locator.getPathVariable(route, function (params: any) {
          _self.param = params['param'];
          if ('logout' === _self.param) {
            _self.logout();
          } else if ('session' === _self.param) {
           _self.handleSessionExpiry();
          } else if (_self.param != null && _self.param.length > 10) {
            _self.keyLogin(_self.param);
          } else if (_self.param === null || _self.param === undefined) {
            let authKey = localStorage.getItem('authKey');
            if (authKey != null && authKey.length > 10) {
              _self.keyLogin(authKey);
            }
          }
        });
      });
  }

  override ngOnInit() {
    let _self = this;
    _self.clearLocalStorage();
    _self.locator.config
      .getProperty('CONTEXT_PATH')
      .then((property: string) => {
        let keySuffix = property + '-';
        let uc = localStorage.getItem(keySuffix + 'userContext');
        if (uc != null) {
          _self.locator.userContext = JSON.parse(uc);
          _self.locator.router.navigateByUrl('/dashboard');
        } else {
          _self.eService.menuChanged('');
          _self.eService.sessionEnd('');
        }
      });
  }

  override populateForm(form: any, data: any) {
    form.data.loginId = data.loginId;
    form.data.password = data.password;
    form.data.googleToken = data.googleToken;
  }

  override validateForm(form: any) {}

  /**
   * Sign in a user
   */
  public signIn() {
    var _self = this;
    let url = _self.locator.config.get('endpoint.auth') + '/sso/login';

    this.locator.http.post(
      url,
      this.form.data,
      async function (res: any, error: any) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.form.message = '';
        _self.form.inputerror = {};

        _self.form.error = !res.success;
        if (_self.locator.dataValidator.isNotNullObject(res.result.message)) {
          _self.form.message = res.result.message;
        }

        if (
          _self.locator.dataValidator.isNotNullObject(res.result.inputerror)
        ) {
          _self.form.inputerror = res.result.inputerror;
        }

        if (_self.locator.dataValidator.isTrue(res.success)) {
          //Server  Start

          let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';

          localStorage.setItem(keySuffix + 'token', res.result.token);

          localStorage.setItem(keySuffix + 'sessionId', res.result.jsessionid);
          let str = JSON.stringify(res.result.data);
          _self.locator.userContext = JSON.parse(str);
          _self.auth = res.result.data.skey;

          const isauth: any = await _self.someAsyncOperation();
          let issecretKey = JSON.stringify(isauth['secretKey']);
          let isauthenticator = JSON.stringify(isauth['data']['authenticator']);
          if (issecretKey === '1' && isauthenticator === 'true') {
            _self.ShareService.sendData({
              authkeys: _self.auth,
              result: str,
              loginId: res.result.data.loginId,
              roleId: res.result.data.defaultRoleId,
              appId: res.result.data.appId,
            });

            _self.locator.router.navigateByUrl('/googleAuth');
          } else {
            _self.QRCode = isauth['QRcode'];
            _self.ShareService.sendData({
              data: _self.QRCode,
              authkeys: _self.auth,
              secretKey: isauth['data']['secretKey'],
              result: str,
              loginId: res.result.data.loginId,
              roleId: res.result.data.defaultRoleId,
              appId: res.result.data.appId,
            });
            _self.locator.router.navigateByUrl('/MFA');
          }
        }
      }
    );
  }

  public login() {
    let _self = this;
    let url = _self.locator.config.get('endpoint.login.signin');

    this.locator.http.post(
      url,
      _self.form.data,
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }

        _self.form.message = '';
        _self.form.inputerror = {};

        _self.form.error = !res.success;
        if (_self.locator.dataValidator.isNotNullObject(res.result.message)) {
          _self.form.message = res.result.message;
        }

        if (
          _self.locator.dataValidator.isNotNullObject(res.result.inputerror)
        ) {
          _self.form.inputerror = res.result.inputerror;
        }

        if (_self.locator.dataValidator.isTrue(res.success)) {
          let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
          localStorage.setItem('keySuffix', keySuffix);
          localStorage.setItem(keySuffix + 'loginId', res.result.data.loginId);
          localStorage.setItem(keySuffix + 'sessionId', res.result.jsessionid);
          localStorage.setItem(keySuffix + 'skey', res.result.data.skey);
          localStorage.setItem(keySuffix + 'appId', res.result.data.appId);
          localStorage.setItem(
            keySuffix + 'roleId',
            res.result.data.defaultRoleId
          );
          let str = JSON.stringify(res.result.data);
          localStorage.setItem(keySuffix + 'userContext', str);

          _self.locator.userContext = JSON.parse(str);
          _self.eService.menuChanged('');
          _self.locator.router.navigateByUrl('/dashboard');
        }
      }
    );
  }
  /**
   *
   * @param skey Login by Auth Key
   */
  public keyLogin(skey: any) {
    var _self = this;

    let url = _self.locator.config.get('endpoint.keylogin');

    this.locator.http.get(url, function (res: any, error: any) {
      if (error) {
        return;
      }

      _self.form.message = '';
      _self.form.inputerror = {};

      _self.form.error = !res.success;
      if (_self.locator.dataValidator.isNotNullObject(res.result.message)) {
        _self.form.message = res.result.message;
      }

      if (_self.locator.dataValidator.isNotNullObject(res.result.inputerror)) {
        _self.form.inputerror = res.result.inputerror;
      }

      if (_self.locator.dataValidator.isTrue(res.success)) {
        let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
        localStorage.setItem('keySuffix', keySuffix);
        localStorage.setItem(keySuffix + 'loginId', res.result.data.loginId);
        localStorage.setItem(keySuffix + 'sessionId', res.result.jsessionid);
        localStorage.setItem(keySuffix + 'skey', res.result.data.skey);
        localStorage.setItem(keySuffix + 'appId', res.result.data.appId);
        localStorage.setItem(
          keySuffix + 'roleId',
          res.result.data.defaultRoleId
        );
        let str = JSON.stringify(res.result.data);
        localStorage.setItem(keySuffix + 'userContext', str);
        _self.locator.userContext = JSON.parse(str);
        _self.eService.menuChanged('');
        _self.locator.router.navigateByUrl('/dashboard');
      }
    });
  }

  clearLocalStorage() {
    let _self = this;

    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';

    localStorage.removeItem('keySuffix');
    localStorage.removeItem(keySuffix + 'loginId');
    localStorage.removeItem(keySuffix + 'sessionId');
    localStorage.removeItem(keySuffix + 'skey');
    localStorage.removeItem(keySuffix + 'appId');
    localStorage.removeItem(keySuffix + 'roleId');
    localStorage.removeItem(keySuffix + 'userContext');
    localStorage.removeItem(keySuffix + 'ruleData');
  }

  /**
   * Logout a user
   */
  logout() {
    let _self = this;
    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
    let skey = localStorage.getItem(keySuffix + 'skey');

    let url = _self.locator.config.get('endpoint.login') + '/logout';
    this.locator.http.get(url, function (res: any, error: any) {
      if (error) {
        return;
      }
      _self.clearLocalStorage();
      _self.locator.userContext = {};
      _self.eService.menuChanged('');
      _self.eService.sessionEnd('');
      _self.closeAllModals();
      _self.locator.router.navigateByUrl('/login');
    });
  }

  public signupForm = {
    firstName: '',
    lastName: '',
    login: '',
    password: '',
    googleToken: '',
    orgId: 0,
    role: '',
  };

  signInWithGoogleAPI(user: any) {
    var _self = this;
    console.log('signInWithGoogleAPI' + user.firstName);
    _self.signupForm['googleToken'] = user;

    _self.signupForm['orgId'] = _self.locator.config.get(
      'DEFAULT_ORGNIZATION_ID'
    );
    _self.signupForm['role'] = _self.locator.config.get('DEFAULT_ROLE');
    let url =
      _self.locator.config.get('endpoint.auth') + '/sso/signInWithGoogleAPI';

    this.locator.http.post(
      url,
      _self.signupForm,
      async function (res: any, error: any) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.form.message = '';
        _self.form.inputerror = {};
        _self.form.error = !res.success;
        if (_self.locator.dataValidator.isNotNullObject(res.result.message)) {
          _self.form.message = res.result.message;
        }
        if (
          _self.locator.dataValidator.isNotNullObject(res.result.inputerror)
        ) {
          _self.form.inputerror = res.result.inputerror;
        }

        if (_self.locator.dataValidator.isTrue(res.success)) {
          let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';

          localStorage.setItem(keySuffix + 'sessionId', res.result.jsessionid);
          let str = JSON.stringify(res.result.data);
          _self.locator.userContext = JSON.parse(str);
          _self.auth = res.result.data.skey;

          const isauth: any = await _self.someAsyncOperation();
          let issecretKey = JSON.stringify(isauth['secretKey']);
          let isauthenticator = JSON.stringify(isauth['data']['authenticator']);
          if (issecretKey === '1' && isauthenticator === 'true') {
            _self.ShareService.sendData({
              authkeys: _self.auth,
              result: str,
              loginId: res.result.data.loginId,
              roleId: res.result.data.defaultRoleId,
              appId: res.result.data.appId,
            });

            _self.locator.router.navigateByUrl('/googleAuth');
          } else {
            _self.QRCode = isauth['QRcode'];
            _self.ShareService.sendData({
              data: _self.QRCode,
              authkeys: _self.auth,
              secretKey: isauth['data']['secretKey'],
              result: str,
              loginId: res.result.data.loginId,
              roleId: res.result.data.defaultRoleId,
              appId: res.result.data.appId,
            });
            _self.locator.router.navigateByUrl('/MFA');
          }
        }
      }
    );
  }

  someAsyncOperation(): Promise<string> {
    var _self = this;
    return new Promise((resolve) => {
      setTimeout(() => {
        let url = +'-';
        _self.locator.config.get('GOOGLE_AUTH_API_URL') +
          '/gauth/public/secretKey/' +
          this.auth;
        this.locator.http.get(
          url,
          async function (res: any, error: any) {
            if (error) {
              return;
            }
            if (res.success) {
              resolve(res.result);
            }
          },
          2000
        );
      });
    });
  }

  override form: any = {
    data: { loginId: '', password: '' },
  };

  override clearMessage(obj: any) {
    obj['error'] = false;
    obj['message'] = null;
  }

  //------show Password---------
  showPassword: boolean = false;

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  handleSessionExpiry() {
  this.closeAllModals(); // Close all open modals
  this.clearLocalStorage(); // Clear session data
  this.locator.userContext = {}; // Clear user context
  this.eService.menuChanged(''); // Notify menu change
  this.eService.sessionEnd(''); // Notify session end
  alert('Your session has expired. Please log in again.'); // Notify the user
  this.locator.router.navigateByUrl('/login'); // Redirect to login page
}

  closeAllModals() {
  const modals = document.querySelectorAll('.modal'); // Use '.modal' to target all Bootstrap modals
  modals.forEach((modal: Element) => {
    const htmlModal = modal as HTMLElement; // Cast Element to HTMLElement
    this.renderer.removeClass(htmlModal, 'show'); // Remove the 'show' class to hide the modal
    this.renderer.setAttribute(htmlModal, 'aria-hidden', 'true'); // Set aria-hidden to true
    this.renderer.setStyle(htmlModal, 'display', 'none'); // Set display to none
  });

  // Remove the modal backdrop if it exists
  const modalBackdrop = document.querySelector('.modal-backdrop');
  if (modalBackdrop) {
    this.renderer.removeChild(document.body, modalBackdrop); // Remove the backdrop
  }
}

}
